import React from 'react';
import { Link } from 'react-router-dom';
import { t } from '../utils/translations';
import './SuccessPage.css';

const SuccessPage = () => {
  return (
    <div className="success-container">
      <div className="success-card">
        <div className="success-icon">✓</div>
        <h1>{t('proposalSentSuccessfully')}</h1>
        <p>{t('proposalSentMessage')}</p>
        <div className="success-actions">
          <Link to="/" className="btn-primary">
            {t('createAnotherProposal')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;
